const riskLevelMap = {
  2: {name: '早期隐患', color: '#378def', backgroundColor: '#bad3ef'},
  3: {name: '一般隐患', color: '#efbb37', backgroundColor: '#efe4ba'},
  4: {name: '较大隐患', color: '#ff7a45', backgroundColor: '#f8e0d6'},
  5: {name: '危险隐患', color: '#ed0e20', backgroundColor: '#edd0d2'},
  6: {name: '干扰性缺陷', color: '#6c6c6c', backgroundColor: '#dddddd'},
}
const riskLevel = {
  get(code, key) {
    return (riskLevelMap[code] && riskLevelMap[code][key]) || (key === 'name' ? '暂无隐患' : '#ffffff');
  },
  name(code) {
    return this.get(code, 'name');
  },
  color(code) {
    return this.get(code, 'color');
  },
  backgroundColor(code) {
    return this.get(code, 'backgroundColor');
  },
};
export default riskLevel;
